import { SHORT_TERM_CARE_GRANT_NONE } from "core/consts";
import { isPrintMode } from "core/model/utils/urls";
import { GetOntologyType } from "core/types";
import { VerticalLayout } from "ds_legacy/materials/layouts";
import { margin } from "ds_legacy/materials/metrics";
import { Body } from "ds_legacy/materials/typography";
import { EmptiableField } from "dsl/organisms/PatientProfileDetailsShared/shared";
import { isShortTermGrantChecked } from "dsl/static/StaticShortTermCareGrant";
import { useTranslations } from "translations";

export function ShortTermCareGrant({
  getOntology,
  testId,
  value,
}: {
  getOntology: GetOntologyType;
  testId: string;
  value: number | null | undefined;
}) {
  const translations = useTranslations();
  const isChecked = isShortTermGrantChecked(value);
  const hasValue = value && value !== SHORT_TERM_CARE_GRANT_NONE;
  const isPrint = isPrintMode();
  const title = translations.patient.shortTermCareGrant;

  if (isPrint) {
    if (!isChecked) return null;
    return (
      <Body>
        {title}
        {hasValue &&
          `${translations.general.colon} ${getOntology({
            key: value,
            type: "shortTermGrant",
          })}`}
      </Body>
    );
  }

  return isChecked ? (
    <VerticalLayout margin={margin(0)}>
      <EmptiableField
        testId={testId}
        title={hasValue ? title : ""}
        value={
          hasValue ? getOntology({ key: value, type: "shortTermGrant" }) : title
        }
      />
    </VerticalLayout>
  ) : null;
}
